export const supportedTranslationLanguages = ['fr', 'en'];

export function getBrowserLanguage() {
  if (typeof navigator === 'undefined') {
    return 'en';
  }

  const rawLang = (navigator.languages && navigator.languages[0]) || navigator.language || navigator.userLanguage || '';
  if (!rawLang) {
    return 'en';
  }

  return String(rawLang).split(/[-_]/)[0].toLowerCase();
}

export function getSupportedLanguage() {
  const browserLang = getBrowserLanguage();
  return supportedTranslationLanguages.includes(browserLang) ? browserLang : 'en';
}
